import { Link } from "react-router-dom";
import { Star, Users, BedDouble } from "lucide-react";

export function PropertyCard({ listing, index = 0 }) {
  return (
    <Link
      to={`/logement/${listing.listing_id}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 70}ms` }}
      data-testid={`property-card-${listing.listing_id}`}
    >
      <div className="hover-lift rounded-2xl overflow-hidden bg-white border border-border">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={listing.images?.[0]}
            alt={listing.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {listing.badge && (
            <span className={`absolute top-3 left-3 text-[11px] font-semibold uppercase tracking-wider px-3 py-1 rounded-full text-white ${listing.badge === "Superhôte" ? "bg-olive" : "bg-rose-brand"}`}>
              {listing.badge}
            </span>
          )}
        </div>
        <div className="p-4">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-serif text-lg leading-tight text-olive">{listing.title}</h3>
            <span className="flex items-center gap-1 text-sm text-foreground shrink-0">
              <Star className="w-3.5 h-3.5 fill-rose-brand text-rose-brand" /> {listing.rating ? String(listing.rating).replace(".", ",") : "Nouveau"}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mt-0.5">{listing.location}</p>
          <div className="flex items-center gap-3 mt-3 text-xs text-muted-foreground">
            <span className="flex items-center gap-1"><BedDouble className="w-3.5 h-3.5" /> {listing.bedrooms} ch.</span>
            <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" /> {listing.max_guests} pers.</span>
          </div>
          <p className="mt-3 text-foreground">
            <span className="font-bold text-olive text-lg">{listing.price_per_night} €</span>
            <span className="text-sm text-muted-foreground"> / nuit</span>
          </p>
        </div>
      </div>
    </Link>
  );
}
